import { SUPPORTED_DATE_TIME_LOCALES, type UserDateTimePreferences } from './dateTimePreferences';
import { formatDateTime, resolveDateTimeSettings, type DateTimeSettings } from './dateTimeFormatting';

interface Props {
  value: DateTimeSettings;
  onChange: (preferences: UserDateTimePreferences) => void;
}

export function DateTimePreferenceControls({ value, onChange }: Props) {
  const locale = SUPPORTED_DATE_TIME_LOCALES.find(item => item === value.dateTimeLocale) || null;
  const hourCycle = value.hourCycle === 'h12' || value.hourCycle === 'h23' ? value.hourCycle : null;
  const resolved = resolveDateTimeSettings(value);
  return <>
    <div className="form-group">
      <label htmlFor="profile-date-format">Date Format</label>
      <select id="profile-date-format" value={locale || ''} onChange={event => onChange({ dateTimeLocale: event.target.value as UserDateTimePreferences['dateTimeLocale'] || null, hourCycle })}>
        <option value="">Automatic</option>
        {SUPPORTED_DATE_TIME_LOCALES.map(item => <option key={item} value={item}>{item} ({new Intl.DateTimeFormat(item, { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC' }).format(new Date('2026-10-07T00:00:00Z'))})</option>)}
      </select>
    </div>
    <div className="form-group">
      <label htmlFor="profile-clock-format">Clock</label>
      <select id="profile-clock-format" value={hourCycle || ''} onChange={event => onChange({ dateTimeLocale: locale, hourCycle: event.target.value as UserDateTimePreferences['hourCycle'] || null })}>
        <option value="">Automatic</option>
        <option value="h12">12-hour</option>
        <option value="h23">24-hour</option>
      </select>
    </div>
    <div className="form-group">
      <label>Preview</label>
      <output aria-live="polite">{formatDateTime('2026-10-07T03:05:00Z', {}, value)} ({resolved.timezone})</output>
    </div>
  </>;
}